'use es6';

import ActionTypes from '../constants/ActionTypes';
export default function uninstallModalReducer(uninstallModal, action) {
  switch (action.type) {
    case ActionTypes.SHOW_UNINSTALL_MODAL:
      return uninstallModal.merge({
        modalType: action.payload.modalType,
        goodName: action.payload.goodName,
        goodSubtype: action.payload.goodSubtype,
        open: true,
        assetsWhereGoodInUse: action.payload.assetsWhereGoodInUse,
        packChildrenInUse: action.payload.packChildrenInUse
      });

    case ActionTypes.DISMISSED_UNINSTALL_MODAL:
      return uninstallModal.merge({
        modalType: '',
        goodName: '',
        goodSubtype: '',
        open: false,
        assetsWhereGoodInUse: [],
        packChildrenInUse: []
      });

    default:
      return uninstallModal;
  }
}